import { useAgentCallAgenda, useInterval } from '../../../../shared';
import moment from 'moment';
import * as React from 'react';
import { getIsCSR, keycloak, KeycloakRoles } from '@coverright/shared/keycloak';
import { AgentCallAgendaTaskAssignmentTypeOutput } from '@coverright/data-access/types/enrollment';

export const useCallAgendaMessage = () => {
  const { scheduledReassignAt: reclaimDate, assignedClientsCallTasks, state } = useAgentCallAgenda()
  const [time, setTime] = React.useState('');
  const isCSR = getIsCSR(keycloak);

  useInterval(() => {
    if (reclaimDate) {
      let diff = moment.duration(moment(reclaimDate).diff(moment())).asSeconds()
      if (diff < 0) {
        diff = 0;
      }
      setTime(diff.toFixed(0));
    } else {
      setTime('')
    }
  }, 1000);

  let message = assignedClientsCallTasks.length ? `You have an assigned client` : ''

  if (time) {
    message = `Your assigned client is pending transfer - ${time} seconds left to reclaim`
  }

  if (isCSR) {
    const csrClients = state?.tasks.filter(t => !t.completed && t.currentAssignment?.type === AgentCallAgendaTaskAssignmentTypeOutput.Csr) || [];
    message = csrClients.length ? `Clients requiring processing have appeared` : '';
  }

  return message;
}
